import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, FormControl, UntypedFormGroup } from '@angular/forms';
import { DependentFieldFilters, Field } from '../../shared/interfaces/hubspot-form-data';
import { HubspotOperators } from '../../shared/services/hubspot/hubspot-operators';
import { FormUtilsService } from '../../shared/services/form-utils.service';
import { ValidatorUtils } from '../../shared/services/validator-utils';
import { FormsService } from '../../shared/services/forms.service';
import { BehaviorSubject, Observable, of, Subscription } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { FormsUtils } from '../../shared/forms.utils';

@Component({
    selector: 'da-number',
    templateUrl: './number.component.html',
    styleUrls: ['./number.component.scss'],
    standalone: false
})
export class NumberComponent implements OnInit, OnDestroy {
    private _$isSubmitting: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public field: Field;
    public group: UntypedFormGroup;
    public formId: string;
    public hasFocus = false;
    private _inititalDependentFields: string;
    private _serviceSubscription: Subscription;
    public get showErrors$(): Observable<boolean> {
        const _control = this.group.get(this.field.name);
        const _showErrors = _control.touched || this._$isSubmitting.getValue();
        return of(_showErrors);
    }
    constructor(
        private _hubspotOperators: HubspotOperators,
        private _formUtils: FormUtilsService,
        private _FormsService: FormsService,
        protected _ref: ChangeDetectorRef
    ) {}

    ngOnInit() {
        this._inititalDependentFields = JSON.stringify(this.field.dependentFieldFilters);
        this._serviceSubscription = this._FormsService
            .submitting$(this.formId)
            .pipe(distinctUntilChanged())
            .subscribe((isSubmitting) => {
                if (isSubmitting) {
                    this.group.get(this.field.name).markAsTouched();
                    this._markDependentFieldsAsTouched();
                    this._ref.detectChanges();
                }
                this._$isSubmitting.next(isSubmitting);
            });
    }

    ngOnDestroy() {
        this._serviceSubscription.unsubscribe();
    }
    public hasValue(fieldname: string) {
        const _input = this.group.get(fieldname);
        return _input.value ? FormsUtils.trim(_input.value.toString()) !== '' : false;
    }

    public getVisibilityByDependentFieldFiltersAndSetValidators(
        dependentField: DependentFieldFilters,
        parentField: AbstractControl
    ): boolean {
        const _isVisible = this._hubspotOperators.shouldBeVisible(dependentField, parentField, this.field);
        const _currentDependentField = this.group.get(dependentField.dependentFormField.name);
        const _currentDependentFieldIsRequiredWhenVisible = this._formUtils.isFieldInitiallyRequired(
            dependentField,
            this._inititalDependentFields
        );
        _currentDependentField.setValidators(
            ValidatorUtils.setValidatorsAgain(dependentField, _isVisible, _currentDependentFieldIsRequiredWhenVisible)
        );
        _currentDependentField.updateValueAndValidity();
        return _isVisible;
    }

    private _markDependentFieldsAsTouched() {
        this.field.dependentFieldFilters.forEach((filter) => this.group.get(filter.dependentFormField.name).markAsTouched());
    }
    public getErrorTranslation(error: any): string {
        const errorTranslation = this._formUtils.getErrorTranslation(error, this.group, this.field);
        return this._formUtils.replaceMinMax(this.field, errorTranslation);
    }
}
